// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-overlay[data-v-894341ba]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:2000;background:hsla(0,0%,100%,.78);display:flex;align-items:center;justify-content:center}.loading-content[data-v-894341ba]{background:#fff;border-radius:8px;padding:16px 22px;box-shadow:0 4px 18px rgba(0,0,0,.12)}", ""]);
// Exports
module.exports = exports;
